import { render, staticRenderFns } from "./EditCandidate.vue?vue&type=template&id=b7d48644&scoped=true"
import script from "./EditCandidate.vue?vue&type=script&lang=js"
export * from "./EditCandidate.vue?vue&type=script&lang=js"
import style0 from "./EditCandidate.vue?vue&type=style&index=0&id=b7d48644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d48644",
  null
  
)

export default component.exports